import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { SingleSkeletonLoader } from '../../../components/SingleSkeletonLoader';
import { BrandingAndLimitPriorityFeatures } from '../../../components/merch-card/feature-display/BrandingAndLimitPriorityFeatures';
import { UncategorizedPriorityFeatures } from '../../../components/merch-card/feature-display/UncategorizedPriorityFeatures';
import { useHandleClickFreeToolsWithLimitsLink } from '../../../components/merch-card/feature-display/useHandleClickFreeToolsWithLimitsLink';
import { useIsFreePortal } from '../../../hooks/inventory/useProductInventory';
import { useCategorizedPriorityFeatures } from './useFeaturesDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriorityFeaturesByProductApiName = ({
  productApiName,
  lowerTierMessage
}) => {
  const isMobile = useIsMobile();
  const {
    isFreePortal
  } = useIsFreePortal();
  const handleClickFreeToolsWithLimitsLink = useHandleClickFreeToolsWithLimitsLink();
  const {
    loading: isLoadingPriorityFeatures,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  } = useCategorizedPriorityFeatures({
    productApiName
  });
  if (isLoadingPriorityFeatures) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 96,
      width: "100%"
    });
  }
  if (brandingAndLimitFeatures.length) {
    return /*#__PURE__*/_jsx(BrandingAndLimitPriorityFeatures, {
      brandingAndLimitFeatures: brandingAndLimitFeatures,
      uncategorizedFeatures: uncategorizedFeatures,
      handleClickFreeToolsWithLimitsLink: handleClickFreeToolsWithLimitsLink,
      isCollapsible: isMobile,
      isFreePortal: isFreePortal
    });
  }
  return /*#__PURE__*/_jsx(UncategorizedPriorityFeatures, {
    uncategorizedFeatures: uncategorizedFeatures,
    lowerTierMessage: lowerTierMessage,
    isCollapsible: isMobile
  });
};